import React           from 'react';
import PriceMatrixCell from './price/PriceMatrixCell';

const sizes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const HeadMatrix = () => (
  <thead>
    <tr>
      <th />
      {sizes.map(size => (<th key={size}>{`${size}"`}</th>))}
    </tr>
  </thead>
);

const RowBody = props => (
  <tr>
    <td>{`${props.row}"`}</td>
    {sizes.map(col => (
      <PriceMatrixCell key={`col-${col}`} {...props} col={col} />
    ))}
  </tr>
);

const BodyMatrix = props => (
  <tbody>
    {sizes.map(row => (
      <RowBody key={`row-${row}`} {...props} row={row} />
    ))}
  </tbody>
);

const Matrix = props => (
  <table className="table table-striped">
    <HeadMatrix {...props} />
    <BodyMatrix {...props} />
  </table>
);

export default (props) => {
  return (
    <div className="pcb-price-section">
      <div className="price-matrices">
        <div className="price-matrix">
          <div className="stainless-steel-table table-responsive">
            <Matrix {...props} />
          </div>
        </div>
      </div>
    </div>
  );
};
